export type Benefit = { title: string; text: string }

// "Waarom het goed voor je is" — per product drie concrete voordelen.
export const productBenefits: Record<string, Benefit[]> = {
  'hammam-ritueel-set': [
    { title: 'Alles in één keer', text: 'Vijf producten die op elkaar zijn afgestemd. Je hoeft niets uit te zoeken: open de doos en begin.' },
    { title: 'Zachtere huid vanaf de eerste keer', text: 'Reinigen, scrubben en voeden in de juiste volgorde laat de huid direct merkbaar gladder en soepeler aanvoelen.' },
    { title: 'Voordeliger dan los', text: 'Je bespaart ten opzichte van de losse producten — en het is meteen een stijlvol cadeau.' },
  ],
  arganolie: [
    { title: 'Voedt zonder vet te voelen', text: 'Trekt snel in en laat de huid soepel aanvoelen, zonder plakkerige laag.' },
    { title: 'Eén olie voor alles', text: 'Te gebruiken op gezicht, lichaam, haarpunten en baard. Minder potjes, meer verzorging.' },
    { title: 'Van nature rijk aan vitamine E', text: 'Tocoferolen zijn antioxidanten die de huid helpen beschermen tegen invloeden van buitenaf.' },
  ],
  'savon-beldi': [
    { title: 'Grondig én zacht', text: 'De olijfbasis reinigt de huid diep, zonder dat het ruw of trekkerig aanvoelt.' },
    { title: 'Maakt scrubben effectiever', text: 'Verzacht de bovenste huidlaag, zodat de kessa dode huidcellen moeiteloos verwijdert.' },
    { title: 'Puur en herkenbaar', text: 'Een traditioneel product met een korte, eerlijke samenstelling — zoals het al eeuwen wordt gemaakt.' },
  ],
  kessa: [
    { title: 'Direct voelbaar gladder', text: 'Na één keer scrubben voelt je huid zichtbaar zachter en egaler aan.' },
    { title: 'Minder ingegroeide haartjes', text: 'Regelmatig exfoliëren houdt de haarzakjes vrij en helpt ingegroeide haartjes voorkomen.' },
    { title: 'Je verzorging werkt beter', text: 'Na het scrubben neemt de huid olie en verzorging veel beter op.' },
  ],
  ghassoul: [
    { title: 'Reinigt zonder uit te drogen', text: 'Haalt vuil en onzuiverheden weg, terwijl de huid zacht en comfortabel blijft.' },
    { title: 'Ideaal bij een vette of onzuivere huid', text: 'Absorbeert overtollig talg, zodat de huid er frisser en matter uitziet.' },
    { title: 'Voor huid én haar', text: 'Ook te gebruiken als milde haarwas voor een schone hoofdhuid en luchtig haar.' },
  ],
  rozenwater: [
    { title: 'Verfrist op elk moment', text: 'Een paar sprays geven direct een frisse, lichte huid — ook handig overdag.' },
    { title: 'Zacht voor de huid', text: 'Voelt verzachtend aan en is prettig voor ook de gevoelige huid.' },
    { title: 'Bereidt voor op verzorging', text: 'Een vochtige huid neemt olie of crème beter op. Rozenwater is de perfecte tussenstap.' },
  ],
  cactusvijgolie: [
    { title: 'Voor de droge, trekkerige huid', text: 'Geeft direct comfort en laat de huid weer soepel aanvoelen.' },
    { title: 'Licht en snel intrekkend', text: 'Ideaal onder make-up of als avondverzorging, zonder glimmend resultaat.' },
    { title: 'Ondersteunt de huidbarrière', text: 'Het hoge gehalte linolzuur helpt de huid vocht vast te houden.' },
  ],
  nila: [
    { title: 'Frisse, egale uitstraling', text: 'Een traditioneel masker dat de huid helder en verzorgd laat ogen.' },
    { title: 'Schoonheidsgeheim uit de Sahara', text: 'Al generaties gebruikt door vrouwen in de woestijn voor een stralende huid.' },
    { title: 'Mild masker', text: 'Zacht voor de huid, zonder schuren of prikken.' },
  ],
  tbrima: [
    { title: 'Verzorgende kruidenmix', text: 'Ons eigen mengsel van fijngemalen planten voor een complete bodytreatment.' },
    { title: 'Zacht en geurig', text: 'Laat de huid zacht aanvoelen met een subtiele, natuurlijke kruidengeur.' },
    { title: 'Makkelijk te combineren', text: 'Meng met rozenwater of ghassoul voor jouw eigen verzorgende pasta.' },
  ],
  oranjebloesemwater: [
    { title: 'Frisse start van je dag', text: 'Een lichte mist die de huid direct wakker en fris laat aanvoelen.' },
    { title: 'Ideaal na het scheren', text: 'Verkoelt en verfrist de huid, zonder vettig of plakkerig gevoel.' },
    { title: 'Rustgevende geur', text: 'Oranjebloesem staat bekend om zijn zachte, kalmerende geur.' },
  ],
  musk: [
    { title: 'Zacht en langdurig', text: 'Een warme geur die subtiel blijft hangen en de hele dag meegaat.' },
    { title: 'Prettig op de huid', text: 'Als geurolie droogt hij de huid niet uit zoals veel parfums met alcohol.' },
    { title: 'Klein formaat, groot effect', text: 'Een kleine hoeveelheid is genoeg. Een flesje gaat lang mee.' },
  ],
  oud: [
    { title: 'Diep en uitgesproken', text: 'Een rijke, houtachtige geur met karakter — voor wie opvalt zonder te overheersen.' },
    { title: 'Houdt lang aan', text: 'Ontwikkelt zich geleidelijk en blijft urenlang op de huid.' },
    { title: 'Perfect te combineren', text: 'Laag hem over Musk voor een warme, persoonlijke signatuurgeur.' },
  ],
  'geurset-musk-oud': [
    { title: 'Twee geuren, één cadeau', text: 'Zacht en diep in één set — altijd een geur die past bij het moment.' },
    { title: 'Voor dag én avond', text: 'Musk voor overdag, Oud voor de avond. Of combineer ze voor iets eigens.' },
    { title: 'Direct cadeauklaar', text: 'Stijlvol verpakt, inclusief een gratis kaartje met jouw persoonlijke boodschap.' },
  ],
  'henna-sidr': [
    { title: 'Natuurlijke kleur en glans', text: 'Geeft het haar een warme hennatint en een gezonde glans.' },
    { title: 'Voller aanvoelend haar', text: 'Henna legt zich om de haarschacht, waardoor het haar steviger en voller aanvoelt.' },
    { title: 'Plantaardig', text: 'Op basis van poeders van henna- en sidrbladeren, zonder synthetische kleurstoffen.' },
  ],
  rozenblaadjes: [
    { title: 'Een spa-moment thuis', text: 'Een handvol in warm badwater maakt van elk bad een moment voor jezelf.' },
    { title: 'Verrijkt je masker', text: 'Fijngemalen door ghassoul voor een verzorgend en geurig gezichtsmasker.' },
    { title: 'Natuurlijke antioxidanten', text: 'Rijk aan polyfenolen en flavonoïden uit de Damascusroos.' },
  ],
  kohl: [
    { title: 'Intense, diepe oogopslag', text: 'Accentueert je ogen met een rijke, donkere lijn.' },
    { title: 'Traditioneel en natuurlijk', text: 'Een eeuwenoude eyeliner op basis van natuurlijke ingrediënten.' },
    { title: 'Makkelijk aan te brengen', text: 'Met het stokje trek je in één beweging een zachte, egale lijn.' },
  ],
  'aker-fassi': [
    { title: 'Een natuurlijke blos', text: 'Geeft wangen en lippen een frisse, gezonde kleur.' },
    { title: 'Twee in één', text: 'Te gebruiken als blush én als lipkleur — handig voor onderweg.' },
    { title: 'Opbouwbaar', text: 'Van subtiel tot uitgesproken: jij bepaalt de intensiteit.' },
  ],
  mhekka: [
    { title: 'Zachte voeten', text: 'Verwijdert eelt en ruwe plekken voor gladde hielen en voeten.' },
    { title: 'Gaat lang mee', text: 'Van natuurlijk terracotta: stevig, hygiënisch en jarenlang bruikbaar.' },
    { title: 'Verzorging werkt beter', text: 'Na gebruik nemen olie en voetcrème veel beter op.' },
  ],
}
